import pluck from 'ramda/src/pluck';
import flatten from 'ramda/src/flatten';
import uniq from 'ramda/src/uniq';
import compose from 'ramda/src/compose';
export var getAllUniqueMembersOfAllCustomerHouseholds = function getAllUniqueMembersOfAllCustomerHouseholds(households) {
  return compose(uniq, flatten, pluck('Members'))(households);
};